import React, { useCallback } from "react";

import { withStyles } from "@material-ui/core/styles";

import HexagonMapSlider from "components/HexagonMapSlider";

import { useTranslation } from "react-i18next";

import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";

import { Box } from "@material-ui/core";

const MapSelectorButton = withStyles((theme) => {
  return {
    root: {
      height: "unset",
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(1),
      },
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(2),
      },
    },
    label: {
      lineHeight: "normal",
    },
  };
})(ToggleButton);

export const mapSelectorTypes = {
  choropleth: 1,
  hexagons: 2,
};

export default function MapTypeSelector({
  mapSubType,
  onMapSubTypeChange,
  onHexResolutionChange,
  hexResolution,
}) {

  const { t } = useTranslation();

  const handleMapChange = useCallback(
    (_, newType) => {
      if (newType !== null) {
        onMapSubTypeChange(newType);
      }
    },
    [onMapSubTypeChange]
  );

  return (
    <div style={{ position: "relative" }}>
      <Box dispay="flex" flexDirection="column">
        <Box pb={3}>
          <ToggleButtonGroup
            exclusive
            aria-label="text alignment"
            value={mapSubType}
            onChange={handleMapChange}
          >
            <MapSelectorButton
              value={mapSelectorTypes["choropleth"]}
              aria-label="left aligned"
            >
              {t("map.choroplethButton")}
            </MapSelectorButton>
            <MapSelectorButton
              value={mapSelectorTypes["hexagons"]}
              aria-label="centered"
            >
              {t("map.honeycombButton")}
            </MapSelectorButton>
          </ToggleButtonGroup>
        </Box>
        {mapSubType === mapSelectorTypes.hexagons && (
          <Box style={{textAlign: "right"}}>
            <HexagonMapSlider
              onChange={onHexResolutionChange}
              value={hexResolution}
            />
          </Box>
        )}
      </Box>
    </div>
  );
}
